var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordsearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32_192)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2 38.288C40.7307 38.288 40.3893 38.192 40.176 38C39.984 37.808 39.8667 37.5093 39.824 37.104L39.952 35.504C39.7387 35.8453 39.408 36.24 38.96 36.688C38.512 37.1147 37.9253 37.4987 37.2 37.84C36.4747 38.16 35.5893 38.32 34.544 38.32C33.52 38.32 32.56 38.1173 31.664 37.712C30.7893 37.3067 30.0107 36.7413 29.328 36.016C28.6667 35.2907 28.144 34.4587 27.76 33.52C27.3973 32.5813 27.216 31.5787 27.216 30.512C27.216 29.4667 27.3973 28.4853 27.76 27.568C28.144 26.6293 28.6773 25.808 29.36 25.104C30.0427 24.4 30.8213 23.8453 31.696 23.44C32.592 23.0347 33.5413 22.832 34.544 22.832C35.4827 22.832 36.2827 22.96 36.944 23.216C37.6053 23.4507 38.1707 23.7707 38.64 24.176C39.1307 24.56 39.5573 24.9973 39.92 25.488L39.856 24.144C39.8347 23.6747 39.9307 23.344 40.144 23.152C40.3787 22.9387 40.7413 22.832 41.232 22.832C41.6373 22.832 41.9253 22.896 42.096 23.024C42.288 23.152 42.416 23.3333 42.48 23.568C42.544 23.8027 42.576 24.0907 42.576 24.432V36.784C42.576 37.0827 42.544 37.3493 42.48 37.584C42.416 37.8187 42.288 37.9893 42.096 38.096C41.904 38.224 41.6053 38.288 41.2 38.288ZM35.024 35.632C35.8773 35.632 36.656 35.408 37.36 34.96C38.0853 34.512 38.6507 33.9147 39.056 33.168C39.4827 32.4 39.696 31.5253 39.696 30.544C39.696 29.5413 39.472 28.6667 39.024 27.92C38.5973 27.152 38.0213 26.5547 37.296 26.128C36.592 25.68 35.8133 25.456 34.96 25.456C33.9573 25.456 33.0827 25.6907 32.336 26.16C31.6107 26.608 31.0347 27.216 30.608 27.984C30.1813 28.752 29.968 29.6267 29.968 30.608C29.968 31.568 30.1813 32.432 30.608 33.2C31.0347 33.9467 31.6213 34.544 32.368 34.992C33.136 35.4187 34.0213 35.632 35.024 35.632Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0008 46.0018C38.9793 46.0018 42.7949 44.4213 45.6081 41.6081C48.4213 38.7949 50.0018 34.9793 50.0018 31.0008C50.0018 27.0223 48.4213 23.2067 45.6081 20.3935C42.7949 17.5802 38.9793 15.9998 35.0008 15.9998C31.0223 15.9998 27.2067 17.5802 24.3935 20.3935C21.5802 23.2067 19.9998 27.0223 19.9998 31.0008C19.9998 34.9793 21.5802 38.7949 24.3935 41.6081C27.2067 44.4213 31.0223 46.0018 35.0008 46.0018ZM48.9397 42.3926L58.9994 52.4522L56.4522 54.9994L46.3926 44.9397C42.8167 47.8621 38.2545 49.2984 33.6494 48.9516C29.0443 48.6048 24.7487 46.5014 21.6508 43.0764C18.553 39.6515 16.89 35.1669 17.0057 30.5502C17.1214 25.9336 19.0069 21.5379 22.2724 18.2724C25.5379 15.0069 29.9336 13.1214 34.5502 13.0057C39.1669 12.89 43.6515 14.553 47.0764 17.6508C50.5014 20.7487 52.6048 25.0443 52.9516 29.6494C53.2984 34.2545 51.8621 38.8167 48.9397 42.3926Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32_192",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_192"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_192",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordsearch);
export default __webpack_public_path__ + "static/media/wordsearch.56272bb6c9d37f008c426c8bb1f7e8ed.svg";
export { ForwardRef as ReactComponent };